import {Pipe, PipeTransform} from '@angular/core';
import {DataService} from '../services/data.service';
import {ProposedCar} from '../models/api.models';
import {formatOrderCar} from './order-car-display';

@Pipe({name: 'carDisplay', standalone: false, pure: false})
export class CarDisplayPipe implements PipeTransform {
    constructor(private data: DataService) {
    }

    transform(value: ProposedCar | string | undefined): string {
        if (!value) return '-';
        if (typeof value !== 'string') {
            const known = this.data.getCars()?.find(car => car.CarIdentifier === value.CarIdentifier);
            return formatOrderCar({...known, ...value, CompanyName: value.CompanyName || known?.CompanyName});
        }
        const identifier = value.trim();
        const known = this.data.getCars()?.find(car => car.CarIdentifier === identifier);
        if (known) return formatOrderCar(known);
        const parts = /^(.*?\D)[\s_-]*(\d+)$/.exec(identifier);
        return parts
            ? `${parts[1].replace(/[\s_-]+$/, '').toUpperCase()} ${parts[2]}`
            : identifier.toUpperCase() || '-';
    }
}
